"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var ArrowRight = function ArrowRight(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 24 24",
    height: "24",
    width: "24"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.5,12c0.001,0.662-0.283,1.292-0.78,1.729L7.568,23.54c-0.781,0.656-1.946,0.554-2.602-0.228 c-0.634-0.756-0.562-1.877,0.163-2.545l9.752-8.579c0.104-0.091,0.114-0.249,0.023-0.353c-0.007-0.008-0.015-0.016-0.023-0.023 L5.129,3.233c-0.75-0.691-0.798-1.86-0.106-2.61c0.669-0.726,1.79-0.797,2.545-0.163l11.148,9.808 C19.214,10.706,19.499,11.337,19.5,12z",
    stroke: "none",
    fill: fill,
    strokeWidth: "0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
ArrowRight.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
ArrowRight.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = ArrowRight;